export default __webpack_public_path__ + "static/media/icon-checkmark-checked.3c9bcbc3.svg";